import { Observable } from 'rxjs';

export abstract class TopmotiveCatalogAdapter {
  abstract isAuthorized(targetUrl: string): Observable<boolean>;
}
